export default {
  home: {
    myNft: '私のチケット',
    myEvent: '私のイベント',
    empty: {
      text: '持っているチケットがありません\nさまざまなイベントを探して追加してみてください',
      btn: 'イベントを探す',
    },
  },
  discover: {
    headerTitle: '検索',
    events: 'イベント',
    empty: {
      text: '検索されたイベントがありません。',
    },
    mySale: '私の販売商品',
  },
  discoverDetail: {
    title: '販売チケット詳細',
    eventTitle: 'イベント詳細',
    listTab: '再販売',
    detailTab: 'イベント詳細',
    noticeTab: 'お知らせ',
    more: 'チケットもっと見る',
    detail: '詳細情報',
    eventInfo: 'イベント情報',
    saleEnd: '販売終了',
    applyEnd: '募集が締め切られました。',
    applied: 'すでに応募したイベントです。',
    applyModify: '私の応募内容確認/修正',
    needLogin: 'ログインが必要です。',
    notice: 'お知らせ',
    selectCrcy: '決済通貨を選択',
  },
  paySelect: {
    dateTitle: '日付 & 時間選択',
    title: '{type}選択',
    dateForm: 'YYYY.MM.DD (ddd) A hh:mm',
    timeForm: 'A hh:mm',
    selectDate: '日付選択',
    selectTime: '時間選択',
    selectOption: 'オプション選択',
    selectSeat: '座席選択',
    selectSeatNum: '総{total}席選択',
    selectSeatCplt: '座席選択を確定する',
    buyerInfo: '購入者情報',
    seat: '席',
    empty: '選択できる項目がありません。',
    customer: {
      title: 'チケット予約情報案内のため、\n連絡先情報を入力してください。',
      desc: 'カカオ通知トークまたはメッセージで案内メッセージが送信されます。',
    },
    qtnr: {
      title: 'イベント参加のための\n事前情報をお知らせください。',
    },
    ntfc: {
      leftUpdated: '残量が変更されました。',
    },
  },
payDetail: {
  title: '決済',
      confirm : '下記内容が正しいか確認してください。',
      order: 'お支払いする{type}情報を確認してください',
      pay: '決済情報',
      doPay: '決済する',
      price: '決済金額',
      buyNow: '購入する',
      joinNow: '参加する',
      applyNow: '応募する',
      credits: '残りの使用量',
      venue: '場所',
      dateTime: '日時',
      secondSale: '第2次販売',
      allowTransfer: '送信許可の有無',
      info: '{type}購入情報',
      buyerInfo: '購入者情報',
      ableToResell: '再販売可能',
      unableToResell: '再販売不可能',
      ableToTransfer: '送信可能',
      unableToTransfer: '送信不可能',
      royalties: 'ロイヤリティ',
      maxPrice: '最大価格',
      soldOut: '完売',
      maxPur: '最大購入量超過',
      total: '合計',
      totalTicket: '総{count}チケット',
      sheets: '{count}枚',
      bookingFee: '予約手数料',
      dcDetail: '割引内容',
      maxCnt: '最大購入',
      stock: '残量',
      calculating: '計算中...',
      crcySelect: '通貨選択',
      crcyPay: '{0} で支払う',
      toPaypal: {
    title: 'PayPal決済',
        desc: '選択時にPayPalでの決済が可能です。',
  },
  timeLeft: '残り',
  preparing: '決済準備中です...',
  onlyMmbs: 'メンバーシップ専用イベントです。',
  eligibleMmbs: '参加可能なメンバーシップ',
},
payResult: {
  modalTitle: '決済',
      paying: 'チケット購入進行中',
      issuing: '購入中..\nウィンドウを閉じないでください',
      issuingText: '少々お待ちください',
      issueCplt: '購入成功',
      issueFail: '購入失敗',
      issueFailText: '購入処理中にエラーが発生しました。\n少し経ってから再試行してください',
      waitMinute: '最大待機時間: {minute}分',
      payCplt: '購入完了',
      payCpltText: '購入が完了しました',
      refund: '払い戻し',
      retry: '再試行',
      ntfc: {
    refundCplt: '払い戻しが処理されました。',
  },
},
  refundAlert: {
    title: '本当に払い戻し',
  },
  wc: {
    connected: 'ウォレットが接続されました',
    disconnect: '接続解除',
    readyReq: '{0} で支払うには、ウォレットを連携してください',
    connect: 'ウォレットを連携',
    payAmount: '支払い金額',
    doPay: 'クリックして支払いに署名',
    openWallet: 'ウォレットアプリを開いて署名を完了してください',
    recording: '取引を記録中です。しばらくお待ちください...',
    returnReq: '署名完了後、戻るボタンでこちらに戻り結果をご確認ください。',
    returnConnect: 'ウォレットを接続した後、戻るボタンでここに戻って結果を確認してください。',
    loadingWallet: 'ウォレットモジュールを読み込んでいます...',
    availWallet: '決済可能なウォレット',
    selectNetwork: 'ネットワークを選択してください',
    payWarn: `
* ネットワークごとの手数料（ガス代）と処理速度は異なる場合があります。
* Move Ticketがサポートするネットワークのみで送金してください。
* 異なるネットワークを使用した場合、資産が失われる可能性があります。
`,
    warn: {
      noBal: '残高が不足しています。',
      pause: '支払いが中断されました。',
      disconnectFailed: '接続解除に失敗しました。',
      connectFailed: '接続に失敗しました。',
      expired: '支払い時間が過ぎました。\nもう一度お試しください。',
    }
  },
  listFilter: {
    title: 'フィルター',
    sort: '並び替え基準',
    status: 'チケットの状態',
    new: '新しい順',
    old: '古い順',
    available: '利用可能',
    used: '使用済み',
    all: "すべて",
  },
  start: {
    start: "Mooveを始める",
    register: "会員登録",
    isRegister: "アカウントがないですか？",
    loginEmail: "メールアカウントでログイン",
    loginKakao: "カカオでログイン",
    loginGoogle: "Googleでログイン",
  },
  login: {
    login: "ログイン",
    saveLogin: "ログイン情報を覚えておく",
  },
  register: {
    register: "会員登録",
    loginEmail: "メールアカウントでログイン",
    registerKakao: "カカオで始める",
    registerGoogle: "Googleで始める",
    registerEmail: "メールアカウントで会員登録",
    mooveAgree: "Moove利用約款に同意",
    indvAgree: "個人情報の収集利用に同意",
    marketingAgree: "マーケティング受信チャネルに同意",
    isLogin: "すでにアカウントがありますか？",
    success: ["会員になったことを", "歓迎します。"],
    configCode: "認証パスワード設定",
    phoneConfig: '携帯番号入力',
    continue: '続ける',
  },
  registerExternal: {
    kakao: "カカオアカウントで会員登録",
    google: "Googleアカウントで会員登録",
    title: ["継続するには", "情報の同意が必要です。"],
    process: "情報を確認し同意を進めてください。",
    continue: "続けて会員登録進行",
  },
  emailWait: {
    title: ["メール認証をして", "会員登録を完了してください"],
    process: [
      "登録したメールアドレスに認証メールを送りました。",
      "メールを確認して会員登録を完了してください。",
      "このリンクは24時間後に失効します。",
    ],
    status: "メール認証を待っています...",
  },
  emailExpired: {
    title: ["メール認証リンクが", "すでに失効しました"],
    process: [
      "該当の認証リンクはすでに失効しました。",
      "下のボタンをクリックして",
      "認証リンクを再送し認証を完了してください。",
    ],
    resend: "認証リンクを再送する",
  },
  pwConfig: {
    title: "パスワードを入力してください",
    confirmTitle: ["パスワードを", "もう一度入力してください"],
    nextFaceId: "次回からはFace IDを使用",
    newPwd: "新しいパスワードを入力してください",
    newPwdConfirm: ["パスワードを", "もう一度入力してください"],
  },
  forgotPwd: {
    title: "パスワードを忘れましたか",
    ask: "パスワードをお忘れですか？",
    enterEmail: "メールアドレスを入力してください",
    confirmEmail: "メールを確認してください",
    explain:
        "パスワードをリセットするために登録したメールアドレスを入力してください。",
    backToSignIn: "ログインに戻る",
    sentExplain: "パスワードリセットリンクが下記のメールアドレスに送信されました。",
  },
  resetPwd: {
    title: "パスワードリセット",
    submit: "パスワードリセット",
    ntfc: {
      pwdResetFailed: "パスワードの変更に失敗しました。",
      pwdResetSuccess: "パスワードが変更されました！",
    },
  },
  footer: {
    info: `(株)ゲランターブル
    事業者登録番号 575-87-02196
    通信販売業者 登録番号 第2025-ソウルクァンジン-0208号
    05005 ソウル広津区カンナルロ17キル14-4、101号 
    代表取締役 イ・ドンジュ
    info{'@'}moove.live 02-6959-9998
    
    Guarantable Pte. Lte
    (Singapore) 8 Marina View, #39-04, Asia Square Tower1
    `,
    service: 'サービス利用規約',
    indv: '個人情報処理方針',
  },
  footerMenu: {
    nft: "チケット",
    search: "検索",
    ticket: "チケット",
    scan: "スキャン",
    coupon: "クーポン",
    profile: "設定",
    viewCltn: "コレクション別に見る",
    viewNft: "チケット別に見る",
  },
  period: {
    unlimited: '期限なし',
    max: '最大期間',
    forDays: '{0}日後',
    forAMonth: '1ヶ月間',
    forMonths: '{0}ヶ月間',
  },
  nftMenu: {
    title: 'もっと見る',
    sell: 'チケット販売',
    send: 'チケット送信'
  },
  saleNft: {
    title: 'チケット販売設定',
    period: '販売終了日',
    noTimeLimit: '期限なし',
    setDate: '販売終了日選択',
    endOfSaleDate: '選択販売終了日: {0}',
    selectDate: '販売終了日を選択してください',
    saleBefore: '{0}まで販売します。',
    beforeTimeFormat: 'YYYY. MM. DD',
    beforeDateTimeFormat: 'YYYY. MM. DD A h:mm',
    select: '選択完了',
    register: '販売登録',
    modify: '販売情報修正',
    sellingTitle: 'チケット販売中',
    cancel: '販売キャンセル',
    cancelConfirm: '本当に削除しますか？',
    viewDetail: '販売記事を見る',
    myNftList: '私のチケット',
    moveToMarket: 'マーケットに移動',
    registering: '販売登録中',
    regCplt: '販売登録成功',
    regCpltText: '販売登録に成功しました。',
    regFail: '販売登録失敗',
    regFailText: '販売登録を再試行しますか？\n販売登録を進めない場合は、\n販売登録のキャンセルを選択してください。',
    regCancel: '販売登録キャンセル',
    regRetry: '再試行',
    cautionTitle: 'チケット詳細情報',
    ntfc: {
      canceled: '販売登録がキャンセルされました。',
      modified: '販売情報が修正されました。',
      notInfo: '販売情報がありません。',
    },
    modalTitle: '販売登録',
    willReceive: "販売時精算金額",
    buyerPay: "購入者支払金額",
    priceDesc: '{type}販売価格を設定してください',
  },
  saleNftDetail: {
    title: 'チケット販売詳細',
    remaining: '残り使用量',
    price: '販売価格',
    edit: '修正する',
    delete: '削除する',
    expDate: '有効期間',
    coupons: '残りクーポン',
    venue: 'イベント場所',
    cautions: '詳細情報',
    until: '{0}まで',
    couponCount: '{count}個',
    available: '利用可能',
    used: '使用済み',
  },
  nftImage: {
    title: 'チケットを表示'
  },
  nftType: {
    all: "すべて",
    MEMBERSHIP: "メンバーシップ",
    TICKET: "チケット",
    mmbsCount: '{0}メンバーシップ',
    ticketCount: '{0}チケット'
  },
  qrCard: {
    title: "QRコードをスキャンして開始",
    scan: "QRコードをスキャン",
  },
  nftQtnr: {
    title: 'チケットを受け取る前に、\n事前情報を入力してください。',
    submit: '情報入力完了',
  },
  qtnrInput: {
    default: {
      name: '名前',
      email: 'メールアドレス',
      phone: '携帯番号',
      aflt: '所属',
      dpmt: '部署',
      pstn: '職位',
      nick: 'ニックネーム',
      birth: '生年月日',
    },
    plhd: {
      email: 'メールアドレスを入力してください',
      aflt: '所属を入力してください',
      dpmt: '部署を入力してください',
      pstn: '職位を入力してください',
      nick: 'ニックネームを入力してください',
      name: '名前を入力してください',
      phone: '携帯番号を数字のみ入力してください',
      birth: 'YYYYMMDD',
      etc: 'その他事項を入力してください。',
    },
  },
  nftDetailHistory: {
    title: 'チケット履歴',
    nftTab: 'チケット使用履歴',
    ownerTab: '所有権変更履歴'
  },
  nftHistory: {
    title: "チケット使用履歴",
    payTitle: "チケットペイ使用履歴",
    close: "チケット履歴を閉じる",
    issued: "発行",
    nftUse: "{0} 使用",
    benefitUse: "クーポン使用",
    next: "次の利用を待っています",
    waiting: "待機中...",
    network: "{networkName} {title}",
    timesCount: '{0}回使用',
    useCount: '{0}個使用',
    remain: '残り',
    times: '回',
    available: '利用可能',
    used: '使用済み',
    useHistory: '{0}回使用',
    cancelHistory: '使用キャンセル',
    unlimited: '無制限',
  },
  couponHistory: {
    title: "クーポン使用履歴",
    modalTitle: "クーポン使用履歴",
    canUse: "利用可能",
    used: "使用済み",
    total: "全体",
    coupon: "クーポン",
    use: "クーポン使用",
    noData: "使用したクーポン履歴がありません。",
    allUsed: "クーポン使用が完了しました。",
    couponUse: 'クーポン使用: {0}',
    expired: 'クーポンの有効期限切れ: {0}',
    useFail: '使用失敗: {0}',
  },
  payHistory: {
    monthUse: '{0}月使用金額',
    accUse: '累積使用金額',
  },
  historyType: {
    INVITED: `招待 {type}`,
    AUTH: '認証',
    MINTED: '{0} 発行',
    SEND: '{0} 送信',
    SELL: '{0} 販売',
    FIRST_BUY: '初めての購入',
    USE: '{0} 使用',
    USE_CANCEL: '{type} 使用キャンセル',
    EXPIRED: '有効期限切れ',
    USE_FAIL: '使用失敗',
    SEND_FAIL: '送信失敗',
    SELL_REG: '販売登録',
  },
  nftCard: {
    seatMap: '座席確認',
    seat: '席',
    lock: "ロック中",
    used: "使用済み",
    sending: "送信中",
    sendingLogo: 'チケット送信中..',
    sendingFailed: '送信失敗',
    selling: '販売中',
    regitSelling: '販売登録中',
    regitSellingFail: '販売登録\n失敗',
    solving: '解決する',
    expired: "期限切れ",
    failed: '生成失敗',
    monthUse: '{0}月利用金額',
    nameDateForm: 'M/D A hh:mm',
    entry: '応募数',
    status: {
      TICKET: {
        used: "使用済みのチケットです。",
        expired: "チケットが期限切れです。",
        lock: "イベント当日にロック解除されます。",
      },
      MEMBERSHIP: {
        used: "メンバーシップをすべて使用しました。",
        expired: "メンバーシップが期限切れです。",
        lock: "イベント当日にロック解除されます。",
      },
      loading: {
        title: '{type} ローディング中..',
        desc: '少々お待ちください\n最大待機時間:8分',
      },
      fail: {
        title: '発行失敗',
        purDesc: '発行時に失敗しました。\n再試行しますか？',
        qrDesc: '発行時に失敗しました。\n再試行しますか？',
      },
      qtnr: {
        required: 'ホストが要求した追加情報\n入力後チケット発行が完了します。',
        submit: '参加者追加情報入力',
      },
      wait: {
        required: '当選者発表後にイベントにご参加いただけます。',
      },
      seat: {
        required: '座席選択後\n入場可能です。',
        submit: '座席選択',
        time: '座席選択可能時間',
      }
    },
    eventLock: {
      title: 'まだ使用できません',
      activeTime: 'QRコードの有効化時間',
      timeFormat: 'YYYY. MM. DD (ddd) A hh:mm',
    },
    precautionTitle: "詳細情報",
    precaution: {
      avail: '許可',
      unAvail: '不許可',
      tabs: {
        attendee: '参加者追加情報',
        nft: 'チケット情報',
      },
      reSale: {
        title: '再販売情報',
      },
      transfer: {
        title: '送信の可否',
      },
      description: {
        title: "詳細情報",
        empty: "詳細情報がありません。"
      },
      considerations: {
        title: "考慮事項及び注意事項",
        empty: "考慮",
      },
      qtnr: {
        title: '参加者情報',
        modifyAsk: '参加者追加情報を変更できますか？',
        modifyReq: '変更をリクエストする',
      },
    },
    tag: {
      mmbs: 'メンバーシップ',
      ticket: 'チケット',
    },
    qpass: {
      sent: '入場券がモバイルに\n送信されました。',
      resent: '入場券がモバイルに再送信されました。',
    },
  },
  seatMap: {
    title: '座席位置を見る',
  },
  couponDetail: {
    until: "{date}まで",
    noticeButton: "注意事項",
    notices: {
      place: '使用場所',
      title: "注意事項",
      basic: '注意事項',
      extra: '追加注意事項',
    },
    lock: {
      title: 'まだ使用できません',
      activeTime: 'バーコードの有効化時間',
    },
  },
  couponStatus: {
    unuse: '利用可能',
    used: '使用済み',
    expired: '期限切れ',
    deactive: '一時停止',
    active: '使用中',
  },
  qrScan: {
    myProfileQr: "私のプロファイルQR",
    suggest: "QRコードでチケットを\nすぐに送信して受け取ってください",
  },
  receiveNft: {
    slide: "スライドして所有権認証",
    request: "所有権認証をリクエストします",
    recording: "ブロックチェーンに記録中です",
    auth: {
      MEMBERSHIP: "メンバーシップ会員認証",
      TICKET: "チケット認証",
    },
    passcode: {
      MEMBERSHIP: "メンバーシップ会員認証コード",
      TICKET: "チケット認証コード",
    },
  },
  ticketDetail: {
    sector: "区画",
    row: "列",
    seat: "座席番号",
    date: "日付",
    time: "時間",
    location: "場所",
    dateFormat: 'YYYY. MM. DD/A hh:mm',
  },
  myProfile: {
    title: "私のプロファイル",
    editProfile: "修正",
    deleteProfile: 'プロファイル削除',
    invite: '友達を招待',
    tabs: {
      profileInfo: "プロファイル情報",
      password: "パスワード",
    },
    edit: "変更",
    ntfc: {
      editNickname: "ニックネームが\n変更されました。",
      editPwd: "パスワードが\n変更されました。",
      authPwd: "認証パスワードが\n変更されました。",
    },
    config: {
      changeAuthPwd: "認証パスワード変更",
      change2Step: "2段階認証",
      changeLanguage: "言語変更",
      currentLanguage: "現在の言語",
      chooseLanguage: "言語選択",
      myTrst: '私の取引履歴',
    },
    deleteProfileImg: {
      explain1: '本当にこのプロファイル写真を',
      explain2: '削除しますか？',
      delete: '削除します',
      cancel: 'キャンセル'
    },
    qrText: "上記コードでチケットを受け取ることができます",
    forgetPwd: "パスワードを忘れました",
    twoStepAuthText:
        "登録されたメールに認証コードを送ります。今後、知られていないデバイスでログインするたびに認証コードのリクエストを受けることになります。",
    twoStepInput: ["メールで送信された", "6桁の数字を入力してください。"],
    isHavePwdCode: "コードを受け取れませんでしたか？",
    qrName: "{name}さんのQR",
  },
  withdraw: {
    title: '会員退会',
    header: 'こんにちは、大切な会員様。\n会員退会を希望する場合は、以下の内容を参考にしてください。',
    detail: '- 会員退会後に再加入はできません。',
    ifDisable: '- 現在進行中のイベントが終了するまで退会はできません。すぐに退会を希望する場合は、以下のメールにお問い合わせください。',
    footer: 'Moove Walletから退会を本当に希望される場合は、以下の退会ボタンをクリックしてください。',
  },
  myTrst: {
    purHistory: '購入履歴',
    saleHistory: '販売履歴',
    orderHistory: '注文履歴',
    detail: '詳細を見る',
  },
  orderEdit: {
    title: "注文情報の確認",
    edit: "注文情報の修正",
    edited: "注文情報が修正されました",
    editError: "修正中にエラーが発生しました"
  },
  sendNft: {
    title: "チケットを送る",
    sendByEmail: "メールで送信",
    sendByQrCode: "QRコードで送信",
    emailWill: ["以下のメールアドレス宛に", "チケットが送信されます。"],
    emailInputPlhd: '受信者のメールアドレスを入力してください。',
    emailWarning: "チケットの所有者は受信者のアカウントに変更され、払い戻しはできません。",
    confirmText: [
      "{receiver}さんに ",
      "'{name}' {type}を",
      "送りますか？",
    ],
    success: "送信が完了しました！",
    loading: "ブロックチェーンに記録中です",
  },
  receivePending: {
    title: '情報確認中..',
  },
  receiveNtfc: {
    title: "お知らせ",
    nftReceive: {
      text: "{sender}さんが\n「{name}」{type}を送りました。",
    },
    userInvite: {
      text: '招待メッセージを送った\n{0}さんが\nMooveに参加しました。',
    },
    saleCplt: {
      title: "チケット販売完了",
      text: '販売が完了しました。'
    }
  },
  twoStepAuth: {
    verify: {
      title: "2段階認証が必要です",
      explain: [
        "メールで受け取った6桁のコードを入力した後に",
        "下の認証ボタンをクリックしてください。",
      ],
    },
  },
  invite: {
    header: '友達招待',
    title: '今すぐ、Mooveを友達に\n招待してみましょう',
    desc: 'メールで招待状を送信するか、\nリンクをコピーして招待してください',
    copy: '招待リンクをコピー',
    ntfc: {
      copied: '招待リンクをコピーしました！',
      success: 'メールで招待メッセージを送りました！',
      fail: 'メッセージ送信が失敗しました\n再試行してください',
    },
  },
  cltnDetail: {
    createdBy: "作成者",
    description: "説明",
    showMore: "もっと見る",
    showLess: "折りたたむ",
    ntfc: {
      linkCopy: 'イベントリンクがコピーされました！'
    },
  },
  brandDetail: {
    brand: "ブランド",
    website: "ウェブサイト",
    cltns: "コレクション",
    viewMore: "もっと見る",
    moreAbout: "詳細はこちら",
    readMore: "さらに読む",
    showMore: "もっと見る",
    showLess: "折りたたむ",
  },
  adultIdentify: {
    title: '19歳以上のみイベント応募が可能です。',
    desc: `このイベントに参加するには
    19歳以上の成人認証が必要です。
    青少年保護のため、ログイン後も
    別途成人認証手続きが必要であり、
    成人認証が完了してから応募が可能となります。`,
    action: '成人認証する',
  },
  eventApply: {
    contentTitle: '私のイベント応募内容',
        intro: 'イベント応募内容を入力してください。',
        success: '申請が完了しました！',
        modSuc: '修正が完了しました！',
        update: '応募内容修正する',
  },
  search: {
    placeholder: "検索語を入力してください。",
    noResult: "検索結果がありません。",
    noSearchValue: "検索語を入力してください",
    search: "検索",
    recentSearch: "最近の検索語",
    searching: "検索中です",
    thereIsNoResult: "{0}の検索結果がありません。",
  },
  trstList: {
    buyCnt: '購入件数',
    sellCnt: '販売件数',
    cancelPur: '購入キャンセル',
  },
  cancelPur: {
    title: '購入キャンセル',
    ask: '選択した購入件をキャンセルしますか？',
    cancel: '購入キャンセル',
    refundPrice: '払い戻し予定金額',
    payPrice: '商品金額',
    ticketPrice: 'チケット金額',
    bookingFee: '予約手数料',
    cancelFee: 'キャンセル手数料',
    fail: '購入キャンセルに失敗しました。\n再試行してください。',
    success: '購入キャンセルが完了しました。',
    exceptFee: '予約手数料は払い戻しされません。',
  },
  blockEmail: {
    notExist: "無電子郵件發送紀錄。",
    allowed: "已允許接收行銷郵件資訊。",
    canceled: "已取消接收行銷郵件資訊。",
    allow: "允許接收行銷郵件資訊",
    cancel: "取消接收行銷郵件資訊"
  },
  filter: {
    recent: "最近登録順",
    old: "古",
    name: "名前順",
  },
  currency: {
    krw: 'Won',
    krwUnit: '₩ {0}',
    usd: 'USD',
    usdUnit: '$ {0}',
    eur: 'EUR',
    eurUnit: '€ {0}',
    sgd: 'SGD',
    sgdUnit: 'S$ {0}',
    xrp: 'XRP',
    xrpUnit: '{0} XRP',
    usdt: 'USDT',
    usdtUnit: '{0} USDT'
  },
  address: {
    address: '住所',
    detail: '詳細住所',
    postalCode: '郵便番号',
  },
  common: {
    email: "メールアドレス",
    nickName: "ニックネーム",
    pw: "パスワード",
    currentPw: "現在のパスワード",
    newPw: "新しいパスワード",
    pwConfirm: "パスワード確認",
    required: "必須",
    optional: "任意",
    agree: "同意します",
    disagree: "同意しません。",
    nft: "NFT",
    nftBenefit: "イベント特典",
    validUntil: "有効期限 {date}",
    activeDate: '活性日 {date}',
    network: "ネットワーク",
    address: "アドレス",
    contract: "コントラクト",
    wallet: "ウォレット",
    walletAddress: "ウォレットアドレス",
    nickname: "ニックネーム",
    ok: "確認",
    cancel: "キャンセル",
    save: "保存",
    refresh: "再読み込み",
    share: "共有する",
    download: "ダウンロード",
    logout: "ログアウト",
    send: "送る",
    resend: "再送信",
    verify: "認証",
    collection: "コレクション",
    collections: "コレクション",
    counts: "個",
    count: "個",
    confirm: "確認",
    invite: "招待",
    apply: '適用',
    more: 'もっと見る',
    event: 'イベント',
    next: '次',
    price: '価格',
    open: '公開',
    platformFee: 'プラットフォーム手数料',
    max: '最大',
    period: '期間',
    phone: '携帯電話番号',
    free: '無料',
    soldOut: '完売',
    applying: '参加者募集中',
    ticket: 'チケット',
    close: '閉じる',
    select: '選択する',
  },
  dateFormat: {
    infoDate: 'YYYY-MM-DD A h:mm',
    commonDate: 'YY. MM. DD (ddd) A hh:mm'
  },
  network: {
    KLAYTN: "クレイテン",
    POLYGON: 'ポリゴン',
    XRPL_EVM: 'XRPL EVM',
  },
  status: {
    used: "使用済み",
    expired: "有効期限切れ",
  },
  taxItem: {
    platform: 'プラットフォーム手数料',
    etc: 'その他',
  },
  orderStatus: {
    buy: '決済完了',
    refund: '決済キャンセル完了'
  },
  valid: {
    required: "必須項目です",
    pwdConfirm: "パスワードが一致しません。",
    email: "メール形式ではありません。",
    noEmail: "チケットを送信するメールアドレスを入力してください。",
    notMyEmail: '現在のチケット所有者アカウントです。別のメールアドレスを入力してください。',
    notUser: "アカウントが存在しません。",
    invalidAccInfo: "IDまたはパスワードが正しくありません。",
    invalidPw: "無効なパスワードです。",
    expiredRequest: "リクエストが期限切れです。",
    registered: 'すでに登録されたユーザーです。',
    code6: '6桁すべて入力してください。',
    codeRequired: 'コードを入力してください。',
    pwdRequirements: '最小8文字、1つ以上の小文字、数字、記号または空白を含む。',
    moreThan: '{max}より大きくなければなりません',
    integer: '整数のみ入力可能です',
    posTwo: '小数第二位まで入力可能です。',
    phone: '"-"を除いた番号のみ入力してください。',
    phoneFormat: '正しい番号を入力してください。',
    birthFormat: 'YYYYMMDD形式で入力してください',
    maxLength: '{max}文字以内で入力可能です。',
    minSelect: '{min}個以上選択してください。',
    fileType: 'ファイル形式が許可されていません',
    refCode: '無効なコードです。',
  },
  ntfc: {
    expiredLink: '期限切れのリンクです。',
    resendEmail: "メールが再送信されました。",
    existEventNft: "該当アカウントですでにチケットを受け取ったことがあります。",
    incorrectPasscode: "コードが正しくありません",
    twoStepActivated: "2段階認証が有効化されました",
    twoStepDeactivated: "2段階認証が無効化されました。",
    walletCopied: "ウォレットアドレスがコピーされました",
    logout: "正常にログアウトされました。",
    notVerifiedEmail: '認証されていないメールです。',
    authExpired: '有効な認証情報ではありません。認証メールを再送信してください。',
    expiredPasscode: '期限切れのコードです。メールを再送信してください。',
    qrMintingLimit: '該当コードではこれ以上発行できません。',
    issuingLimit: 'チケットの数量が不足しているため、購入を完了できません。',
    perWalletLimit: 'アカウントごとの購入数を超えました。',
    alreadyInvited: 'すでに招待されたユーザーです。',
    recordingFailed: 'ブロックチェーンの記録に失敗しました。\n少し後に再試行してください。',
    invalidPeriod: 'イベント期間外には使用できません',
    sendError: '送信中にエラーが発生しました',
    regError: '登録中にエラーが発生しました',
    payError: '支払い中にエラーが発生しました',
    refundError: '払い戻し中にエラーが発生しました',
    invalidEvent: '無効なイベントです。',
    alreadyReservedSeat: '該当の座席は\n別の人にすでに選択されています。\n空席を選択してください。',
    seatTimeOut: '決済有効時間が超過しました。\n再度進行してください。',
    seatTotalMax: '最大 {count} 席まで選択可能です。',
    zoneTotalMax: '最大 {count}席購入可能です。',
    payInfoError: '商品情報が期限切れです。\n再度行ってください。',
    notOwned: 'これはあなたが所有する商品ではありません。',
    nonRefundable: '払い戻し不可の商品です。',
    profileImg: 'アップロードに失敗しました。\n下記の画像規格を確認してください。\nサイズ: 5MB以下\n拡張子: jpg, jpeg, png, webp',
    noTicketAcc: "該当するチケットがないアカウントです。",
    sessionExpired: 'セッションの期限が切れました。もう一度お試しください。',
  },
  plhd: {
    enterPasscode: "パスコードを入力してください",
    enterPwd: "パスワードを入力してください",
    emailPlhd: "example{'@'}gmail.com",
    friendEmail: '友達のメールアドレスを入力してください',
    phone: '-を除いた番号のみ入力してください。',
  },
  modal: {
    sendingNft: {
      title: 'チケット送信中',
      desc: 'チケットが送信中です。\n少々お待ちください。'
    },
    sendingFail: {
      title: 'チケット送信失敗',
      desc: 'チケット送信が失敗しました',
      cancel: '送信キャンセル',
      retry: '再試行',
      ntfc: {
        canceled: '送信がキャンセルされました。'
      },
    },
    qrMintFail: {
      title: 'チケット生成失敗',
      desc: 'チケット生成が失敗しました。再試行してください',
      success: 'チケットが生成されました。'
    },
    qtnrModify: {
      title: '変更が必要な情報を\n以下のメールアドレスに送信してください。',
      desc: 'メールアドレス: {email}',
    }
  },
  inAppRoute: {
    desc: 'インアプリブラウザの互換性の問題により、Googleログインを使用できません。\n\n他のログイン方法を試すか、下のボタンをクリックしてリンクをコピーし、デフォルトブラウザを実行してアドレス欄に貼り付けてください。',
    copy: 'リンクをコピー',
    copied: 'リンクがコピーされました！\nデフォルトブラウザを実行して、アドレスバーに貼り付けてください。',
  },
}
